export default function _elem(el, className, HTMLDOM) {
  el = document.createElement(el);
  if (className) {
    el.className = className;
  }
  return HTMLDOM ? el : window.jQuery(el);
};
